/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
`;
